














export default {
  data () {
    return {
      competences: [
        'Analysis and Problem Solving',
        'Profesional Expertise',
        'Learning Agility and Development',
        'Adaptability to Changes',
        'Interpersonal Skills',
        'Teamwork and Team Building',
        'Customer Focus',
        'Spanish and Basic English'
      ]
    }
  }
}
